// extracted by mini-css-extract-plugin
export default {"categoryCardImage":"CategoryCard-module__categoryCardImage--yxzxs","categoryCard":"CategoryCard-module__categoryCard--BXZ5W"};